<admin-app-header *ngIf="!isSalesManagerMode"></admin-app-header>
<sales-manager-header *ngIf="isSalesManagerMode"></sales-manager-header>

<!-- Page Header - Mobile (outside container for edge-to-edge) -->
<div class="page-header-mobile mobile-only">
    <h1>Parker CRM</h1>
    <div class="mobile-actions">
        <button class="mobile-btn mobile-btn--primary" (click)="openNewLeadModal()">
            <i class="fa-solid fa-plus"></i>
        </button>
        <button class="mobile-btn" [class.active]="showMobileFilters" (click)="showMobileFilters = !showMobileFilters; showMobileSettings = false">
            <i class="fa-solid fa-filter"></i>
            <span class="filter-indicator" *ngIf="filterForm.get('search')?.value || filterForm.get('filterLeadStatus')?.value?.length || filterForm.get('filterUserResponsible')?.value"></span>
        </button>
        <button class="mobile-btn" [class.active]="showMobileSettings" (click)="showMobileSettings = !showMobileSettings; showMobileFilters = false">
            <i class="fa-solid fa-cog"></i>
        </button>
    </div>
</div>

<!-- Mobile Settings Dropdown (outside container) -->
<div class="mobile-settings-panel" *ngIf="showMobileSettings">
    <button class="mobile-setting-item" [class.active]="view === 'users'" (click)="switchView('users'); showMobileSettings = false">
        <i class="fa-solid fa-users"></i>
        <span>User List</span>
    </button>
    <button class="mobile-setting-item" [class.active]="view === 'board'" (click)="switchView('board'); showMobileSettings = false">
        <i class="fa-solid fa-columns"></i>
        <span>Board View</span>
    </button>
    <button class="mobile-setting-item" (click)="openColumnConfig(); showMobileSettings = false">
        <i class="fa-solid fa-table-columns"></i>
        <span>Configure Columns</span>
    </button>
    <button class="mobile-setting-item" [class.active]="view === 'table'" (click)="switchView('table'); showMobileSettings = false">
        <i class="fa-solid fa-table"></i>
        <span>Table View</span>
    </button>
    <button class="mobile-setting-item" [class.active]="view === 'stats'" (click)="switchView('stats'); showMobileSettings = false">
        <i class="fa-solid fa-chart-bar"></i>
        <span>Stats View</span>
    </button>
    <button class="mobile-setting-item" (click)="showHelpModal = true; showMobileSettings = false">
        <i class="fa-solid fa-circle-question"></i>
        <span>Help</span>
    </button>
</div>

<!-- Mobile Filters (outside container) -->
<div class="filters-card-mobile" [class.mobile-visible]="showMobileFilters">
    <form class="filters-grid-mobile" [formGroup]="filterForm">
        <select class="filter-select" formControlName="filterDateRange">
            <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
        </select>
        <input *ngIf="isCustomDateRange" type="date" class="filter-input" formControlName="customStartDate" />
        <input *ngIf="isCustomDateRange" type="date" class="filter-input" formControlName="customEndDate" />
        <div class="filter-search">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" class="filter-input" placeholder="Search..." formControlName="search" />
        </div>
        <select class="filter-select" formControlName="filterUserResponsible" *ngIf="!isSalesManagerMode">
            <option value="">All Users</option>
            <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
        </select>
        <select class="filter-select" formControlName="filterStatusCategory">
            <option value="active">Active</option>
            <option value="all">All</option>
            <option value="closed">Closed</option>
            <option value="converted">Converted</option>
        </select>
        <select class="filter-select" *ngIf="allTags.length > 0" [ngModel]="filterTags.length === 1 ? filterTags[0] : filterTags.length > 1 ? '__multiple__' : ''" [ngModelOptions]="{standalone: true}" (ngModelChange)="onTagDropdownChange($event)">
            <option value="">All Tags</option>
            <option *ngFor="let tag of allTags" [value]="tag">{{ tag }}</option>
        </select>
        <button class="clear-filters-btn" type="button" (click)="clearFilters()" data-tooltip="Clear Filters">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <button class="starred-filter-btn" [class.active]="showStarredOnly" (click)="toggleStarredFilter()" data-tooltip="Show starred only">
            <i [class]="showStarredOnly ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
        </button>
    </form>
</div>

<div class="crm-page">
    <div class="container-fluid">
        <!-- Page Header - Desktop (Stats view) -->
        <div class="page-header desktop-only" *ngIf="view === 'stats'">
            <h1>Parker CRM Stats</h1>
            <div class="page-header__actions">
                <button class="btn btn-secondary" (click)="switchView('table')"><i class="fa-solid fa-arrow-left"></i> Back to CRM</button>
                <form [formGroup]="filterForm" class="stats-date-filter">
                    <select class="filter-select" formControlName="filterDateRange">
                        <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
                    </select>
                    <input *ngIf="isCustomDateRange" type="date" class="filter-input" formControlName="customStartDate" />
                    <input *ngIf="isCustomDateRange" type="date" class="filter-input" formControlName="customEndDate" />
                </form>
            </div>
        </div>

        <!-- Page Header - Desktop (Non-stats views) -->
        <div class="page-header desktop-only" *ngIf="view !== 'stats'">
            <h1>Parker CRM</h1>
            <div class="page-header__actions">
                <button class="btn btn-primary" (click)="openNewLeadModal()" *ngIf="view !== 'users'"><i class="fa-solid fa-plus"></i> New Lead</button>
                <button class="btn btn-secondary" (click)="openColumnConfig()" *ngIf="view === 'table'"><i class="fa-solid fa-table-columns"></i> Columns</button>
                <div class="view-toggle">
                    <button class="toggle-btn" [class.active]="view === 'users'" (click)="switchView('users')"><i class="fa-solid fa-users"></i> Users</button>
                    <button class="toggle-btn" [class.active]="view === 'board'" (click)="switchView('board')"><i class="fa-solid fa-columns"></i> Board</button>
                    <button class="toggle-btn" [class.active]="view === 'table'" (click)="switchView('table')"><i class="fa-solid fa-table"></i> Table</button>
                    <button class="toggle-btn" [class.active]="view === 'stats'" (click)="switchView('stats')"><i class="fa-solid fa-chart-bar"></i> Stats</button>
                </div>
                <button class="btn btn-secondary" (click)="showHelpModal = true"><i class="fa-solid fa-circle-question"></i> Help</button>
            </div>
        </div>

        <!-- Filters - Desktop (hidden on users and stats views) -->
        <div class="filters-card desktop-only" *ngIf="view !== 'users' && view !== 'stats'">
            <div class="filters-row">
                <form class="filters-grid" [formGroup]="filterForm">
                    <select class="filter-select" formControlName="filterDateRange">
                        <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
                    </select>

                    <input *ngIf="isCustomDateRange" type="date" class="filter-input" formControlName="customStartDate" />
                    <input *ngIf="isCustomDateRange" type="date" class="filter-input" formControlName="customEndDate" />

                    <div class="filter-search">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <input type="text" class="filter-input" placeholder="Search..." formControlName="search" />
                    </div>

                    <select class="filter-select" formControlName="filterUserResponsible" *ngIf="!isSalesManagerMode">
                        <option value="">All Users</option>
                        <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
                    </select>

                    <select class="filter-select" formControlName="filterStatusCategory">
                        <option value="active">Active</option>
                        <option value="all">All</option>
                        <option value="closed">Closed</option>
                        <option value="converted">Converted</option>
                    </select>

                    <select class="filter-select" *ngIf="allTags.length > 0" [ngModel]="filterTags.length === 1 ? filterTags[0] : filterTags.length > 1 ? '__multiple__' : ''" [ngModelOptions]="{standalone: true}" (ngModelChange)="onTagDropdownChange($event)">
                        <option value="">All Tags</option>
                        <option *ngFor="let tag of allTags" [value]="tag">{{ tag }}</option>
                    </select>

                    <button class="clear-filters-btn" type="button" (click)="clearFilters()" data-tooltip="Clear Filters">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </form>
                <button class="starred-filter-btn" [class.active]="showStarredOnly" (click)="toggleStarredFilter()" data-tooltip="Show starred only">
                    <i [class]="showStarredOnly ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                </button>
            </div>
        </div>

        <!-- User List View -->
        <div *ngIf="searchReady && view === 'users'" class="users-view">
            <div class="users-search-bar">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input type="text" [(ngModel)]="userListSearch" placeholder="Search by name, email, phone, company..." class="users-search-input" />
                <span class="users-count">{{ getFilteredUserList().length | number }} users</span>
                <button
                    *ngIf="!isSalesManagerMode && selectedUserIds.length"
                    type="button"
                    class="users-delete-btn"
                    [disabled]="deletingUsers"
                    (click)="deleteSelectedUsers()"
                >
                    <i *ngIf="deletingUsers" class="fa fa-circle-notch fa-spin"></i>
                    <span *ngIf="!deletingUsers">Delete selected ({{ selectedUserIds.length }})</span>
                    <span *ngIf="deletingUsers">Deleting...</span>
                </button>
            </div>
            <div class="users-table-card">
                <table class="users-table" id="all-clients">
                    <thead>
                        <tr>
                            <th *ngIf="!isSalesManagerMode" class="user-select-col">
                                <input type="checkbox" [checked]="areAllVisibleUsersSelected()" (change)="toggleSelectAllVisibleUsers($event)" />
                            </th>
                            <th>Name</th>
                            <th>Company</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Location</th>
                            <th>Created</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let client of getFilteredUserList()" (click)="openLeadDetail(client)" class="user-row" [class.user-row-selected]="isUserSelected(client)">
                            <td *ngIf="!isSalesManagerMode" class="user-select-col" (click)="$event.stopPropagation()">
                                <input type="checkbox" [checked]="isUserSelected(client)" (click)="onUserCheckboxClick($event, client)" />
                            </td>
                            <td class="user-name-cell">
                                <span class="user-avatar-sm" [style.background-color]="getInitialColor(client)">{{ getInitials(client) }}</span>
                                <span>{{ client.firstName || 'No Name' }} {{ client.lastName || '' }}</span>
                            </td>
                            <td>{{ client.companyName || '-' }}</td>
                            <td>{{ client.email || '-' }}</td>
                            <td>{{ client.phoneNumber || '-' }}</td>
                            <td>{{ client.broadLocation || '-' }}</td>
                            <td>{{ client.createdAt?.toDate() | date: 'mediumDate' }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="users-empty" *ngIf="getFilteredUserList().length === 0">
                    <i class="fa-solid fa-users-slash"></i>
                    <p>No users found</p>
                </div>
            </div>
        </div>

        <!-- Board View -->
        <div *ngIf="searchReady && view === 'board'">
            <app-parker-board
                [adminClients]="filteredAdminClients"
                [crmAssigneeMap]="crmAssigneeMap"
                [filterStatusCategory]="filterForm.get('filterStatusCategory')?.value || 'active'"
                (leadClicked)="openLeadDetail($event)"
                (statusChanged)="onBoardStatusChange($event)"
                (starToggled)="toggleStar($event)"
            ></app-parker-board>
        </div>

        <!-- Results Count -->
        <div class="results-count" *ngIf="searchReady && view === 'table'">
            <span class="count-badge">{{ filteredAdminClients.length | number }}</span> entries
        </div>

        <!-- Table Container - Desktop -->
        <div class="table-card desktop-only" *ngIf="searchReady && view === 'table'">
            <app-parker-table
                [filteredAdminClients]="filteredAdminClients"
                [visibleColumns]="visibleColumns"
                [sortColumn]="sortColumn"
                [sortDirection]="sortDirection"
                [crmAssignees]="crmAssignees"
                [crmAssigneeMap]="crmAssigneeMap"
                [isSalesManagerMode]="isSalesManagerMode"
                (leadClick)="openLeadDetail($event)"
                (sortChange)="onSortChange($event)"
            >
            </app-parker-table>
        </div>

        <!-- Mobile Cards View -->
        <div class="mobile-cards mobile-only" *ngIf="searchReady && view === 'table'">
            <div class="lead-card" *ngFor="let client of filteredAdminClients" (click)="openLeadDetail(client)" (contextmenu)="onMobileCardContext($event, client)" [class.starred]="client.isStarred">
                <div class="lead-card__header">
                    <div class="lead-card__name">
                        <button class="star-btn-mobile" [class.starred]="client.isStarred" (click)="toggleStar(client); $event.stopPropagation()">
                            <i [class]="client.isStarred ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                        </button>
                        <span class="name">{{ client.firstName || 'No Name' }} {{ client.lastName }}</span>
                    </div>
                    <span *ngIf="client.leadStatus" [class]="'badge lead-status lead-status--' + client.leadStatus.toLowerCase().replace(' ', '-')">
                        {{ client.leadStatus }}
                    </span>
                </div>
                <div class="lead-card__body">
                    <div class="lead-card__meta">
                        <span class="meta-item" *ngIf="client.numberOfBays"> <i class="fa-solid fa-car"></i> {{ client.numberOfBays }} bays </span>
                        <span class="meta-item" *ngIf="client.monthsRequired"> <i class="fa-solid fa-calendar"></i> {{ client.monthsRequired }} mo </span>
                        <span class="meta-item" *ngIf="client.broadLocation"> <i class="fa-solid fa-location-dot"></i> {{ client.broadLocation }} </span>
                    </div>
                    <div class="lead-card__note" *ngIf="client.latestComment || client.comment">
                        <i class="fa-solid fa-comment"></i>
                        <span class="note-text">{{ client.latestComment?.text || client.comment | truncate: [60, '...'] }}</span>
                        <span class="note-count" *ngIf="client.commentsCount && client.commentsCount > 1">+{{ client.commentsCount - 1 }}</span>
                    </div>
                </div>
                <div class="lead-card__footer">
                    <span class="lead-card__date">{{ client.createdAt | formatDate }}</span>
                    <span *ngIf="crmAssigneeMap[client.userResponsible || '']" class="lead-card__user" [style.background-color]="crmAssigneeMap[client.userResponsible || '']?.badgeColor || '#6c757d'">
                        {{ crmAssigneeMap[client.userResponsible || '']?.displayName }}
                    </span>
                </div>
            </div>

            <!-- Empty state for mobile -->
            <div class="mobile-empty" *ngIf="filteredAdminClients.length === 0">
                <i class="fa-solid fa-inbox"></i>
                <p>No leads found</p>
            </div>
        </div>

        <!-- Stats View -->
        <app-parker-stats *ngIf="searchReady && view === 'stats'" [filteredAdminClients]="statsAdminClients" [crmAssigneeMap]="crmAssigneeMap"></app-parker-stats>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="!searchReady">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <p>Loading clients...</p>
        </div>
    </div>
</div>

<!-- Column Config Modal -->
<div class="modal-overlay" *ngIf="showColumnConfig" (click)="closeColumnConfig()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-table-columns"></i> Configure Columns</h2>
            <button class="modal-close" (click)="closeColumnConfig()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <p class="modal-description">Select which columns to display in the table. Your preferences will be saved for 365 days.</p>

            <div class="column-grid">
                <label *ngFor="let col of allColumns" class="column-checkbox">
                    <input type="checkbox" [checked]="visibleColumns[col.key]" (change)="toggleColumn(col.key)" />
                    <span class="checkmark"></span>
                    <span class="column-label">{{ col.label }}</span>
                </label>
            </div>

            <div class="modal-actions">
                <button class="btn btn-secondary" (click)="selectAllColumns()">Select All</button>
                <button class="btn btn-secondary" (click)="deselectAllColumns()">Deselect All</button>
                <button class="btn btn-primary" (click)="closeColumnConfig()">Done</button>
            </div>
        </div>
    </div>
</div>

<!-- Lead Detail Modal -->
<app-parker-profile-panel
    *ngIf="showLeadDetail && selectedLead"
    [lead]="selectedLead"
    [crmAssignees]="crmAssignees"
    [crmAssigneeMap]="crmAssigneeMap"
    [isSalesManagerMode]="isSalesManagerMode"
    [contactTypes]="contactTypes"
    [leadStatuses]="leadStatuses"
    (closePanel)="closeLeadDetail()"
    (fieldUpdated)="updateLeadField($event.field, $event.value)"
    (userResponsibleUpdated)="updateUserResponsible($event)"
    (emailClicked)="sendEmail($event)"
    (phoneClicked)="callPhone($event)"
    (whatsappClicked)="sendWhatsApp($event)"
    (sendTemplateRequested)="onSendTemplateFromPanel($event)"
    (starToggled)="toggleStar($event)"
    (addressUpdated)="updateLeadAddress($event)"
    (tagAdded)="addTagToLead($event)"
    (tagRemoved)="removeTagFromLead($event)"
    (createTagRequested)="createAndAddTag()"
></app-parker-profile-panel>

<!-- New Lead Modal -->
<div class="modal-overlay" *ngIf="showNewLeadModal" (click)="closeNewLeadModal()">
    <div class="modal-card modal-card--medium" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-user-plus"></i> Create New Lead</h2>
            <button class="modal-close" (click)="closeNewLeadModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="newLeadForm" (ngSubmit)="createNewLead()">
                <div class="lead-form-grid">
                    <div class="form-field">
                        <label>First Name *</label>
                        <input type="text" formControlName="firstName" placeholder="First name" />
                    </div>
                    <div class="form-field">
                        <label>Last Name</label>
                        <input type="text" formControlName="lastName" placeholder="Last name" />
                    </div>
                    <div class="form-field form-field--full">
                        <label>Company Name</label>
                        <input type="text" formControlName="companyName" placeholder="Company name" />
                    </div>
                    <div class="form-field">
                        <label>Email</label>
                        <input type="email" formControlName="email" placeholder="email@example.com" />
                    </div>
                    <div class="form-field">
                        <label>Phone Number</label>
                        <input type="tel" formControlName="phoneNumber" placeholder="+27 XX XXX XXXX" />
                    </div>
                    <div class="form-field">
                        <label>Number of Bays</label>
                        <input type="number" formControlName="numberOfBays" placeholder="0" />
                    </div>
                    <div class="form-field">
                        <label>Months Required</label>
                        <input type="number" formControlName="monthsRequired" placeholder="0" />
                    </div>
                    <div class="form-field">
                        <label>Broad Location</label>
                        <select formControlName="broadLocation">
                            <option value="">Select Location</option>
                            <option *ngFor="let loc of broadLocations" [value]="loc">{{ loc }}</option>
                        </select>
                    </div>
                    <div class="form-field">
                        <label>User Responsible</label>
                        <select formControlName="userResponsible">
                            <option value="">Select User</option>
                            <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
                        </select>
                    </div>
                    <div class="form-field">
                        <label>Contact Type</label>
                        <select formControlName="contactType">
                            <option *ngFor="let type of contactTypes" [value]="type">{{ type }}</option>
                        </select>
                    </div>
                    <div class="form-field">
                        <label>Source</label>
                        <select formControlName="p_source">
                            <option *ngFor="let src of leadSourceOptions" [value]="src">{{ src }}</option>
                        </select>
                    </div>
                </div>

                <div class="manual-lead-badge">
                    <i class="fa-solid fa-hand"></i>
                    <span>This lead will be marked as manually added</span>
                </div>

                <div class="modal-actions">
                    <button type="button" class="btn btn-secondary" (click)="closeNewLeadModal()">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!newLeadForm.valid || isCreatingLead">
                        <i *ngIf="isCreatingLead" class="fa-solid fa-spinner fa-spin"></i>
                        <span *ngIf="!isCreatingLead">Create Lead</span>
                        <span *ngIf="isCreatingLead">Creating...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Help Modal -->
<div class="modal-overlay" *ngIf="showHelpModal" (click)="showHelpModal = false">
    <div class="modal-card modal-card--large" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-circle-question"></i> CRM Help Guide</h2>
            <button class="modal-close" (click)="showHelpModal = false">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body help-body">
            <div class="help-section">
                <h3><i class="fa-solid fa-star"></i> Star Leads</h3>
                <p>Click the star icon on any row to mark important leads. Starred leads always appear at the top of the list.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-plus"></i> Create New Lead</h3>
                <p>Click "New Lead" to manually add a lead. These leads are marked with a hand icon and can be set as User, Lead, or Landlord types.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-filter"></i> Filtering</h3>
                <p>Use the filter dropdowns to narrow your search. Filters are saved in the URL, so you can share filtered views or bookmark them.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-bookmark"></i> Save Searches</h3>
                <p>Click "Save" to save your current filter combination. Access saved searches from the "Saved" dropdown to quickly return to frequently used views.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-table-columns"></i> Customize Columns</h3>
                <p>Click "Columns" to show/hide columns and customize your table view. Your preferences are saved locally.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-sort"></i> Sorting</h3>
                <p>Click any column header to sort by that column. Click again to reverse the sort order. A caret indicates the current sort.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-mouse-pointer"></i> Row Actions</h3>
                <p>Click any row to open the lead detail popup. Right-click for quick actions like changing status or assigning users.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-comments"></i> Comments</h3>
                <p>Add comments to leads from the detail popup. The latest comment shows in the Notes column with a badge showing total count.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-chart-bar"></i> Stats View</h3>
                <p>Switch to "Stats" view for aggregated statistics by status, user, location, and more.</p>
            </div>

            <div class="help-section">
                <h3><i class="fa-solid fa-tags"></i> Lead Statuses</h3>
                <div class="status-legend">
                    <span class="badge lead-status lead-status--new">New</span>
                    <span class="badge lead-status lead-status--contact-attempted">Contact Attempted</span>
                    <span class="badge lead-status lead-status--contacted">Contacted</span>
                    <span class="badge lead-status lead-status--prospecting">Prospecting</span>
                    <span class="badge lead-status lead-status--negotiating">Negotiating</span>
                    <span class="badge lead-status lead-status--converted">Converted</span>
                    <span class="badge lead-status lead-status--closed">Closed</span>
                </div>
            </div>
        </div>
    </div>
</div>
